import { FirebaseDocument } from "common/models/FirebaseDocument";
import { CostPlan } from "./models";
import { CostPlanExport } from "modules/costPlan/models/CostPlanExport";

class Service {
  CostPlan(doc?) {
    if (doc.data) {
      let data = doc.data();
      if (data) {
        let docModel = new CostPlan(
          data.description,
          data.fileName,
          data.name,
          data.progress,
          data.status,
          data.wbsProjectBudget,
          data.projectBound,
          data.message,
          data.type,
          data.modifyAt
        );
        return new FirebaseDocument<CostPlan>(doc.id, docModel);
      }
    }
    return new FirebaseDocument<CostPlan>(doc.id, CostPlan.getDefault());
  }

  CostPlanExport(doc?) {
    if (doc.data) {
      let data = doc.data();
      if (data) {
        let docModel = new CostPlanExport(
          data.development,
          data.name,
          data.status,
          data.wbsProjectBudget,
          data.fileName,
          data.message
        );
        return new FirebaseDocument<CostPlanExport>(doc.id, docModel);
      }
    }
    return new FirebaseDocument<CostPlanExport>(
      doc.id,
      CostPlanExport.getDefault()
    );
  }
}

let CostPlanModels = new Service();

export { CostPlanModels };



// WEBPACK FOOTER //
// ./src/modules/costPlan/CostPlanModels.ts